import React from 'react';
import './ErrorBoundary.css';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, errorMessage: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message ?? '' };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className='eb-screen'>
        <div className='eb-card'>
          <div className='eb-icon'>⚠️</div>
          <h2 className='eb-title'>Oups, quelque chose s'est mal passé</h2>
          <p className='eb-desc'>
            Une erreur inattendue s'est produite. Cela peut être causé par
            votre connexion ou une extension de navigateur.
          </p>
          <button className='eb-btn' onClick={this.handleReload}>
            Recharger l'application
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
